import styled from 'styled-components';
import RecentItem from './RecentItem';
import { Fragment } from 'react';
import { useIndexedDBState } from '../../context/indexedDBContext';
import iConEmpty from '../../img/ico_nodoc.png';
import iConEmpty2x from '../../img/ico_nodoc@2x.png';
import hwpEmpty from '../../img/ico_nodoc_hwp.png';
import hwpEmpty2X from '../../img/ico_nodoc_hwp@2x.png';
import sheetEmpty from '../../img/ico_nodoc_sheet.png';
import sheetEmpty2X from '../../img/ico_nodoc_sheet@2x.png';
import slideEmpty from '../../img/ico_nodoc_slide.png';
import slideEmpty2X from '../../img/ico_nodoc_slide@2x.png';
import { useTranslation } from 'react-i18next';
import { DOCUMENT_TYPE, DOC_FORMAT_CONFIG_VALUES } from '../../define/global';
import { useCallback } from 'react';

const RecentListStyle = styled.ul`
  padding-left: 0;
  margin: 0;
  list-style-type: none;
`;

const RecentListEmpty = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
  margin: 0;
  box-sizing: border-box;
`;

const EmptyImage = styled.img`
  width: 100px;
  height: 100px;
  margin-bottom: 16px;
  box-sizing: border-box;
`;

const EmptyText = styled.span`
  font-size: 13px;
  font-weight: 400;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: ${(props) => props.textColor};
`;

function RecentList({ isFrom, openDocument }) {
  const { t } = useTranslation();
  const indexedDBState = useIndexedDBState();
  const getEmptyIcon = useCallback(() => {
    switch (DOC_FORMAT_CONFIG_VALUES.sdk.documnetType) {
      case DOCUMENT_TYPE.HWP:
      case DOCUMENT_TYPE.WORD:
        return {
          icon: hwpEmpty,
          icon2x: hwpEmpty2X,
          textColor: '#99c3ef'
        };
      case DOCUMENT_TYPE.SHEET:
        return {
          icon: sheetEmpty,
          icon2x: sheetEmpty2X,
          textColor: '#a4cc8c'
        };
      case DOCUMENT_TYPE.SLIDE:
        return {
          icon: slideEmpty,
          icon2x: slideEmpty2X,
          textColor: '#f3bc7c'
        };
      default:
        return {
          icon: iConEmpty,
          icon2x: iConEmpty2x,
          textColor: '#96999c'
        };
    }
  }, []);

  const { icon, icon2x, textColor } = getEmptyIcon();

  if (indexedDBState.status === 'unsupported') {
    return (
      <RecentListEmpty>
        <EmptyText>{t('RecentList.UnsupportedRecentList')}</EmptyText>
      </RecentListEmpty>
    );
  }

  return (
    <Fragment>
      {indexedDBState.files && indexedDBState.files.length > 0 ? (
        <RecentListStyle>
          {indexedDBState.files &&
            indexedDBState.files
              .filter((item) => !item.isNaverWorksFile) // 네이버웍스 파일은 최근문서에 표시하지 않는다.
              .map((fileInfo, index) => {
                return (
                  <RecentItem
                    key={index}
                    fileInfo={fileInfo}
                    openDocument={openDocument}
                    isFrom={isFrom}
                  />
                );
              })}
        </RecentListStyle>
      ) : (
        <RecentListEmpty>
          <EmptyImage src={icon} srcSet={icon2x} />
          <EmptyText textColor={textColor}>{t('RecentList.NoRecentList')}</EmptyText>
        </RecentListEmpty>
      )}
    </Fragment>
  );
}

export default RecentList;
